import ClipperLib from 'clipper-lib';
import { dividerLines, hasGrille } from './dividerLayout';

// Colonial grid clipped to the arched glass outline (leaf-local metres).
export function archGrillePaths(glass, dividers, center) {
  if (!hasGrille(dividers)) return [];
  const S = 1e6, t = Number(dividers.bar_width_in) * .0254, xs = glass.map(p => p[0]), ys = glass.map(p => p[1]);
  const left = Math.min(...xs), bottom = Math.min(...ys), w = Math.max(...xs) - left;
  const sun = dividers.pattern === 'sunburst', top = Math.max(...ys);
  // The fan centres on the whole door's arch, so French doors share one sunburst across both leaves.
  const [cx, spring] = center || [left + w / 2, top - w / 2], r = Math.max(...glass.filter(([, y]) => y > spring + .01).map(([x, y]) => Math.hypot(x - cx, y - spring)));
  const h = (sun ? spring : top) - bottom;
  const toClip = points => points.map(([X, Y]) => ({ X: Math.round(X * S), Y: Math.round(Y * S) }));
  const rect = (x, y, bw, bh) => toClip([[x, y], [x + bw, y], [x + bw, y + bh], [x, y + bh]]);
  const bars = dividerLines({ ...dividers, pattern: sun ? 'grid' : dividers.pattern }).map(l => l.y1 === l.y2 ? rect(left, bottom + l.y1 * h - t / 2, w, t) : rect(left + l.x1 * w - t / 2, bottom + l.y1 * h, t, (l.y2 - l.y1) * h));
  if (sun) bars.push(rect(left, spring - t / 2, w, t), ...sunburstParts(cx, spring, r, t, Number(dividers.rays)).map(toClip));
  const clip = glass.map(([x, y]) => ({ X: Math.round(x * S), Y: Math.round(y * S) }));
  // Clip bars one at a time so crossing bars never merge into a shape with holes.
  return bars.flatMap(bar => {
    const clipper = new ClipperLib.Clipper(), out = [];
    clipper.AddPath(bar, ClipperLib.PolyType.ptSubject, true); clipper.AddPath(clip, ClipperLib.PolyType.ptClip, true);
    clipper.Execute(ClipperLib.ClipType.ctIntersection, out, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
    return out.map(path => path.map(p => [p.X / S, p.Y / S]));
  });
}

// Hub half-ring plus evenly fanned rays above the spring line.
function sunburstParts(cx, cy, r, t, rays) {
  const hub = .24 * r, arc = (radius, from, to) => Array.from({ length: 17 }, (_, i) => { const a = from + (to - from) * i / 16; return [cx + radius * Math.cos(a), cy + radius * Math.sin(a)]; });
  const ring = [...arc(hub + t / 2, 0, Math.PI), ...arc(hub - t / 2, Math.PI, 0)];
  return [ring, ...Array.from({ length: rays }, (_, i) => {
    const a = Math.PI * (i + 1) / (rays + 1), dx = Math.cos(a), dy = Math.sin(a), nx = -dy * t / 2, ny = dx * t / 2, far = 2 * r;
    return [[cx + dx * hub + nx, cy + dy * hub + ny], [cx + dx * far + nx, cy + dy * far + ny], [cx + dx * far - nx, cy + dy * far - ny], [cx + dx * hub - nx, cy + dy * hub - ny]];
  })];
}
